<template>
<div id='cover-template'>
    <div class='navbar-atas'>
        <div class="container flex-nav">
            <div id='logo-nav'>
                <h3>QUR'AN ID</h3>
            </div>
            <div id='link-nav'>
                <ul class='list-link'>
                    <li><router-link to='/'>Beranda</router-link></li>
                    <li><router-link to='/sholat'>Sholat</router-link></li>
                    <li><router-link to='/riwayat'>Riwayat</router-link></li>
                </ul>
            </div>
            <div id='change-color'>
                <button @click="handleQuestion()" type='button' class='color-pellete'><i class="fas fa-question"></i></button>
            </div> 
        </div>
    </div>
    <!-- bagian navbar bottom -->
    <div class="navbar-bottom">
        <div id='box-nav'>
            <router-link to='/'>
                <i class="fa fa-home"></i>
                <span>Beranda</span>
            </router-link>
        </div>
        <div id='box-nav'>
            <router-link to='/sholat'>
                <i class="fa fa-pray"></i>
                <span>Sholat</span>
            </router-link>
        </div>
        <div id='box-nav'>
            <router-link to='/riwayat'>
                <i class="fa fa-clock"></i>
                <span>Riwayat</span>
            </router-link>
        </div>
    </div>
</div>
</template>

<style lang="css" scoped>
    .navbar-atas
    {
        width: 100%;
        height: auto;
        padding: 1% 0% 0.5% 0%;
        background-color: transparent;
        position: fixed;
        z-index: 1200;
        top: 0;
    }
    .flex-nav 
    {
        width: 100%;
        display: flex;
        justify-content: space-beetwen;
        align-items: center;
    }
    #logo-nav
    {
        width: 15%;
        font-weight: bold;

    }
    #link-nav
    {
        width: 75%;
        text-align: center;
    }
    .list-link 
    {
        padding: 0;
    }
    .list-link li 
    {
        display: inline;
        padding: 0% 2% 0% 2%;
    }
    .list-link a
    {
        color: #756060;
        text-decoration: none;
        transition: 0.3s;
        padding-bottom: 1%;
    }
    .list-link a:hover{
        border-bottom: 3px solid #756060;
        text-decoration: none;
    }
    .list-link a:focus{
        font-weight: bold;
        border-bottom: 3px solid #756060;
    }
    #change-color 
    {
        width: 10%;
        text-align: center;
    }
    .color-pellete 
    {
        border: none;
        background-color: transparent;
        color: #756060;
    }
    .color-pellete:focus{
        outline: none;
    }
    @media screen and (max-width: 780px)
    {
        .flex-nav
        {
            justify-content: space-between;
            align-items: center;
            padding-top: 1%;
        }
        #link-nav 
        {
            display: none;
        }
        #logo-nav
        {
            width: 50%;
        }
    }

    /* navbar bottom */
    .navbar-bottom 
    {
        width: 100%;
        position: fixed;
        z-index: 1000;
        bottom : 0;
        display: flex;
        background-color: white;
        box-shadow: 0px -5px 20px 2px rgba(0,0,0,0.1);
        padding: 2% 5% 1% 5%;
        display: none;
    }
    #box-nav 
    {
        width: 33.34%;
        height: auto;
        position: relative;
        text-align: center;
    }
    #box-nav a 
    {
        color: #756060;
        text-decoration: none;
    }
    #box-nav:hover{
        font-weight: bold;
        text-decoration: none;
    }
    #box-nav i 
    {
        display: block;
    }
    #box-nav span 
    {
        font-size: 14px;
    }
    @media screen and (max-width: 780px)
    {
        .navbar-bottom
        {
            display: flex;
        }
        .navbar-atas
        {
            padding: 2% 0% 2% 0%;
        }
    }
    .warna-nav 
    {
        box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.1);
        transition: 0.3s;
        background-color: white;
    }
</style>

<script>
export default{
    data(){
        return{

        }
    },
    mounted(){
        const navbar = document.querySelector('.navbar-atas');
        
        window.addEventListener('scroll', () => {
            if( document.body.scrollTop > 10 || document.documentElement.scrollTop > 10 )
            {
                navbar.classList.add('warna-nav');
            }else
            {
                navbar.classList.remove('warna-nav');
            }
        })
    },
    methods: {
        handleQuestion: function(){
            window.location.href = "https://github.com/rizki4106";
        }
    }
}
</script>